<template>
  <BaseLoading
    v-if="isUserLoading"
    full-screen
  />
  <LandingPage v-else-if="!isUserLoggedIn" />
  <MainTemplate v-else>
    <MainNavbar
      slot="header"
      has-small-logo
    />
    <MainFooter slot="footer" />
    <HomeLoggedIn />
  </MainTemplate>
</template>

<script>
import { mapState } from 'vuex'
import MainNavbar from '@/layout/MainNavbar'
import MainTemplate from '@/layout/Templates/MainTemplate'
import MainFooter from '@/layout/MainFooter'
import BaseLoading from '@/components/Atoms/BaseLoading'

const HomeLoggedIn = () => import('./Routes/Home/HomeLoggedIn')
const LandingPage = () => import('@/pages/Home/Routes/LandingPage/LandingPage')

export default {
  components: {
    BaseLoading,
    MainFooter,
    LandingPage,
    MainTemplate,
    MainNavbar,
    HomeLoggedIn,
  },
  computed: {
    ...mapState({
      isUserLoading: state => state.auth.isUserLoading,
      isUserLoggedIn: state => !!state.auth.token,
    }),
  },
}
</script>
